import React from 'react';
import { Link } from 'gatsby';
import {
  Highlight,
} from 'react-instantsearch-hooks-web';
import type { Hit as AlgoliaHit } from 'instantsearch.js/es/types';
import { IndexTypeEnum } from 'utils/enums';
import * as styles from './search-styles.module.scss';

interface PageHitProps {
  hit: AlgoliaHit<{
    slug: string;
    title: string;
    description?: string;
  }>;
  sendEvent: (
    eventType: string,
    hit: AlgoliaHit<{
      slug: string;
      title: string;
      description?: string;
    }>, eventName: string) => void;
}

export const getIndexPath = (indexName: string, category?: string) => {
  if (indexName === IndexTypeEnum.articles || indexName === IndexTypeEnum.reviews) return category;
  return '';
};

const PageHit = ({ hit, sendEvent }: PageHitProps) => (
  <div>
    <Link to={`/${hit.slug}`} onClick={() => sendEvent('click', hit, 'Clicked')}>
      <div className={styles.resultContainer}>
        <div className={styles.resultText}>
          <h4 className={styles.resultTitle}>
            <Highlight attribute="title" hit={hit} classNames={{ highlighted: styles.highlightedText }} />
          </h4>
          {hit.description && (
            <span className={styles.resultDescription}>
              <Highlight attribute="description" hit={hit} classNames={{ highlighted: styles.highlightedText }} />
            </span>
          )}
        </div>
      </div>
    </Link>
  </div>
);
export default PageHit;
